import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import {
  Button,
  Row,
  Col,
  Input,
  Label,
  ButtonGroup,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import axios from "axios";
import moment from "moment";

function ReporteContadora() {
  const { user } = useContext(AuthContext);

  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;

  let hoy = new Date();
  const endDate = moment(hoy).format("YYYY-MM-DD");

  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startOfMonth);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [reporte, setReporte] = useState({
    "Deglose Ventas por Notas": 0,
    "Desglose de gastos": 0,
    "Cuentas por Cobrar Clientes": 0,
    "Cuentas por Pagar Proveedores": 0,
  });

  const [loading, setLoading] = useState(false);

  // ===== Modal Detalle =====
  const [modalDetalle, setModalDetalle] = useState(false);
  const [detalleLoading, setDetalleLoading] = useState(false);
  const [detalleTitulo, setDetalleTitulo] = useState("");
  const [detalleTipo, setDetalleTipo] = useState("");
  const [detalleRows, setDetalleRows] = useState([]);

  const money = (v) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(v) || 0);

  const headers = useMemo(
    () => ({
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    }),
    []
  );

  // ====== Fetch resumen ======
  useEffect(() => {
    const fetchReporte = async () => {
      try {
        setLoading(true);

        const { data } = await axios.get(
          `${URL_ARTICULOS_SURTIDOS}ReporteContadora/${selectedFechaInicio}/${selectedFechaFin}`,
          { headers }
        );

        setReporte({
          "Deglose Ventas por Notas":
            Number(data?.["Deglose Ventas por Notas"]) || 0,
          "Desglose de gastos": Number(data?.["Desglose de gastos"]) || 0,
          "Cuentas por Cobrar Clientes":
            Number(data?.["Cuentas por Cobrar Clientes"]) || 0,
          "Cuentas por Pagar Proveedores":
            Number(data?.["Cuentas por Pagar Proveedores"]) || 0,
        });
      } catch (err) {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo cargar el reporte.",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchReporte();
  }, [URL_ARTICULOS_SURTIDOS, selectedFechaInicio, selectedFechaFin, headers]);

  // ====== Data para pantalla / pdf / excel ======
  const rows = useMemo(() => {
    return [
      {
        opcion: "Deglose Ventas por Notas",
        tipo: "ventas",
        resultado: reporte["Deglose Ventas por Notas"],
      },
      {
        opcion: "Desglose de gastos",
        tipo: "gastos",
        resultado: reporte["Desglose de gastos"],
      },
      {
        opcion: "Cuentas por Cobrar Clientes",
        tipo: "clientes",
        resultado: reporte["Cuentas por Cobrar Clientes"],
      },
      {
        opcion: "Cuentas por Pagar Proveedores",
        tipo: "proveedores",
        resultado: reporte["Cuentas por Pagar Proveedores"],
      },
    ];
  }, [reporte]);

  // ====== Cargar detalle ======
  const abrirDetalle = async (row) => {
    try {
      setDetalleTitulo(row.opcion);
      setDetalleTipo(row.tipo);
      setDetalleRows([]);
      setModalDetalle(true);
      setDetalleLoading(true);

      const { data } = await axios.get(
        `${URL_ARTICULOS_SURTIDOS}ReporteContadoraDetalle/${row.tipo}/${selectedFechaInicio}/${selectedFechaFin}`,
        { headers }
      );

      setDetalleRows(Array.isArray(data) ? data : []);
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo cargar el desglose.",
      });
    } finally {
      setDetalleLoading(false);
    }
  };

  // ====== Columnas dinámicas detalle ======
  const detalleColumns = useMemo(() => {
    if (!detalleRows.length) return [];
    return Object.keys(detalleRows[0]);
  }, [detalleRows]);

  // ====== PDF resumen ======
  // function descargarPDF() {
  //   const doc = new jsPDF();

  //   const img = new Image();
  //   img.src = process.env.PUBLIC_URL + "/Logo-Lynqro-PDF.png";
  //   try {
  //     doc.addImage(img, "PNG", 150, 10, 33, 10);
  //   } catch (e) {}

  //   const img2 = new Image();
  //   img2.src = process.env.PUBLIC_URL + "/logoInstitucion.png";
  //   try {
  //     doc.addImage(img2, "PNG", 150, 23, 35, 25);
  //   } catch (e) {}

  //   doc.text("Reporte Contadora", 20, 30);
  //   doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);

  //   const body = rows.map((r) => [r.opcion, money(r.resultado)]);

  //   doc.autoTable({
  //     head: [["Opción", "Resultado"]],
  //     body,
  //     startY: 50,
  //     styles: { fontSize: 9 },
  //     headStyles: { fillColor: [40, 40, 40] },
  //   });

  //   doc.save(`ReporteContadora-${selectedFechaInicio}-${selectedFechaFin}.pdf`);
  // }
async function descargarPDF() {
  try {
    setLoading(true);

    const detallesConfig = [
      { tipo: "ventas", titulo: "Desglose Ventas por Notas", totalKey: "Total" },
      { tipo: "gastos", titulo: "Desglose de gastos", totalKey: "Total" },
      { tipo: "clientes", titulo: "Cuentas por Cobrar Clientes", totalKey: "Saldo" },
      { tipo: "proveedores", titulo: "Cuentas por Pagar Proveedores", totalKey: "Saldo" },
    ];

    const responses = await Promise.all(
      detallesConfig.map((item) =>
        axios.get(
          `${URL_ARTICULOS_SURTIDOS}ReporteContadoraDetalle/${item.tipo}/${selectedFechaInicio}/${selectedFechaFin}`,
          { headers }
        )
      )
    );

    const doc = new jsPDF("p", "mm", "a4");

    const agregarLogos = () => {
      const img = new Image();
      img.src = process.env.PUBLIC_URL + "/Logo-Lynqro-PDF.png";
      try {
        doc.addImage(img, "PNG", 150, 10, 33, 10);
      } catch (e) {}

      const img2 = new Image();
      img2.src = process.env.PUBLIC_URL + "/logoInstitucion.png";
      try {
        doc.addImage(img2, "PNG", 150, 23, 20, 14);
      } catch (e) {}
    };

    const agregarTitulo = (titulo) => {
      agregarLogos();
      doc.setFontSize(14);
      doc.text(titulo, 20, 25);
      doc.setFontSize(10);
      doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 32);
    };

    const esCampoMoneda = (col) => {
      const c = String(col || "").toLowerCase();
      return (
        c.includes("total") ||
        c.includes("saldo") ||
        c.includes("importe")
      );
    };

    const truncarTexto = (valor, max = 40) => {
      const texto = String(valor ?? "");
      if (texto.length <= max) return texto;
      return texto.substring(0, max) + "...";
    };

    // =========================
    // 1) RESUMEN
    // =========================
    agregarTitulo("Reporte Contadora");

    const bodyResumen = rows.map((r) => [r.opcion, money(r.resultado)]);
    const totalResumen = rows.reduce(
      (acc, r) => acc + (Number(r.resultado) || 0),
      0
    );

    bodyResumen.push(["TOTAL", money(totalResumen)]);

    doc.autoTable({
      head: [["Opción", "Resultado"]],
      body: bodyResumen,
      startY: 40,
      styles: { fontSize: 9 },
      // headStyles: { fillColor: [40, 40, 40] },
      didParseCell: function (data) {
        if (data.row.index === bodyResumen.length - 1) {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [230, 230, 230];
        }
      },
    });

    // =========================
    // 2) DETALLES
    // =========================
    detallesConfig.forEach((item, index) => {
      const detalle = Array.isArray(responses[index].data)
        ? responses[index].data
        : [];

      doc.addPage();
      agregarTitulo(item.titulo);

      if (!detalle.length) {
        doc.text("No hay información.", 20, 45);
        return;
      }

      const columns = Object.keys(detalle[0]);

      const totalDetalle = detalle.reduce(
        (acc, row) => acc + (Number(row?.[item.totalKey]) || 0),
        0
      );

      const body = detalle.map((row) =>
        columns.map((col) => {
          const value = row[col];

          if (typeof value === "number" && esCampoMoneda(col)) {
            return money(value);
          }

          return truncarTexto(value, 35);
        })
      );

      const totalRow = columns.map((col, colIndex) => {
        if (col === item.totalKey) return money(totalDetalle);
        if (colIndex === 0) return "TOTAL";
        return "";
      });

      body.push(totalRow);

      doc.autoTable({
        head: [columns],
        body,
        startY: 40,
        styles: {
          fontSize: 8,
          cellWidth: "wrap",
          overflow: "linebreak",
        },
        // headStyles: { fillColor: [40, 40, 40] },
        margin: { left: 8, right: 8 },
        didParseCell: function (data) {
          if (data.row.index === body.length - 1) {
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.fillColor = [230, 230, 230];
          }
        },
        columnStyles: columns.reduce((acc, col, i) => {
          const lower = String(col).toLowerCase();

          if (lower.includes("fecha")) {
            acc[i] = { cellWidth: 22 };
          } else if (lower.includes("total") || lower.includes("saldo")) {
            acc[i] = { cellWidth: 28, halign: "right" };
          } else if (
            lower.includes("cliente") ||
            lower.includes("proveedor") ||
            lower.includes("descripcion") ||
            lower.includes("observaciones") ||
            lower.includes("concepto")
          ) {
            acc[i] = { cellWidth: 45 };
          } else {
            acc[i] = { cellWidth: "auto" };
          }

          return acc;
        }, {}),
      });
    });

    doc.save(`ReporteContadora-${selectedFechaInicio}-${selectedFechaFin}.pdf`);
  } catch (err) {
    console.log(err);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "No se pudo descargar el PDF completo.",
    });
  } finally {
    setLoading(false);
  }
}

  async function descargarExcel() {
  try {
    setLoading(true);

    const resumenSheet = rows.map((r) => ({
      Opcion: r.opcion,
      Resultado: Number(r.resultado) || 0,
    }));

    const detallesConfig = [
      {
        tipo: "ventas",
        titulo: "Ventas",
      },
      {
        tipo: "gastos",
        titulo: "Gastos",
      },
      {
        tipo: "clientes",
        titulo: "Clientes",
      },
      {
        tipo: "proveedores",
        titulo: "Proveedores",
      },
    ];

    const responses = await Promise.all(
      detallesConfig.map((item) =>
        axios.get(
          `${URL_ARTICULOS_SURTIDOS}ReporteContadoraDetalle/${item.tipo}/${selectedFechaInicio}/${selectedFechaFin}`,
          { headers }
        )
      )
    );

    const datas = [
      {
        sheetData: resumenSheet,
        sheetName: "Resumen",
        sheetFilter: ["Opcion", "Resultado"],
        sheetHeader: ["Opcion", "Resultado"],
      },
    ];

    detallesConfig.forEach((item, index) => {
      const detalle = Array.isArray(responses[index].data)
        ? responses[index].data
        : [];

      const detalleNormalizado = detalle.map((row) => {
        const obj = {};
        Object.keys(row || {}).forEach((key) => {
          obj[key] =
            typeof row[key] === "number" ? Number(row[key]) : row[key] ?? "";
        });
        return obj;
      });

      const columns =
        detalleNormalizado.length > 0
          ? Object.keys(detalleNormalizado[0])
          : ["SinDatos"];

      datas.push({
        sheetData:
          detalleNormalizado.length > 0
            ? detalleNormalizado
            : [{ SinDatos: "No hay información" }],
        sheetName: item.titulo,
        sheetFilter: columns,
        sheetHeader: columns,
      });
    });

    const option = {};
    option.fileName = `ReporteContadora-${selectedFechaInicio}-${selectedFechaFin}`;
    option.datas = datas;

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  } catch (err) {
    console.log(err);
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "No se pudo descargar el Excel completo.",
    });
  } finally {
    setLoading(false);
  }
}

  function descargarExcelDetalle() {
  if (!detalleRows.length) {
    Swal.fire("Sin datos", "No hay información para exportar", "info");
    return;
  }

  const sheetData = detalleRows.map((row) => {
    const obj = {};

    Object.keys(row).forEach((key) => {
      obj[key] = typeof row[key] === "number" ? Number(row[key]) : row[key];
    });

    return obj;
  });

  const option = {};
  option.fileName = `${detalleTitulo}-${selectedFechaInicio}-${selectedFechaFin}`;

  option.datas = [
    {
      sheetData,
      sheetName: "Detalle",
      sheetFilter: Object.keys(sheetData[0]),
      sheetHeader: Object.keys(sheetData[0]),
    },
  ];

  const toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}

  return (
    <>
      <Header />
      <br />
      <br />

      {user.menu_admin ? (
        <div className="card col-12 p-3">
          <Row className="align-items-center">
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuAdmin"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>

            <Col md={4} className="d-flex justify-content-end">
              <ButtonGroup>
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={descargarPDF}
                  disabled={loading}
                >
                  PDF <i className="far fa-file-pdf" />
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={descargarExcel}
                  disabled={loading}
                >
                  Excel <i className="far fa-file-excel" />
                </Button>
              </ButtonGroup>
            </Col>
          </Row>

          <h3 className="mt-3 text-center">Reporte Contadora</h3>

          <Row className="mt-3">
            <Col md={3}>
              <Label>Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => setSelectedFechaInicio(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => setSelectedFechaFin(e.target.value)}
              />
            </Col>
          </Row>

          <div className="mt-4 table-wrapper">
            <Table size="sm" striped borderless className="table-responsive-xl">
              <thead>
                <tr>
                  <th>Opción</th>
                  <th className="text-end">Resultado</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr
                    key={r.opcion}
                    style={{ cursor: "pointer" }}
                    onClick={() => abrirDetalle(r)}
                  >
                    <td>
                      <u>{r.opcion}</u>
                    </td>
                    <td className="text-end">{money(r.resultado)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      ) : null}

      <Modal
        isOpen={modalDetalle}
        toggle={() => setModalDetalle(!modalDetalle)}
        size="xl"
      >
       <ModalHeader toggle={() => setModalDetalle(!modalDetalle)}>
  <div className="d-flex justify-content-between w-100 align-items-center">
    <span>
      {detalleTitulo} ({selectedFechaInicio} - {selectedFechaFin})
    </span>

    
  </div>
</ModalHeader>
<Col md={2}>
<Button
      size="sm"
      color="primary"
      onClick={descargarExcelDetalle}
      disabled={detalleLoading || !detalleRows.length}
    >
      Excel <i class="far fa-file-excel"></i>
    </Button>
    </Col>
        <ModalBody>
          {detalleLoading ? (
            <div className="text-center p-4">
              <Spinner />
            </div>
          ) : detalleRows.length === 0 ? (
            <div className="text-center p-3">No hay información.</div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <Table bordered striped size="sm">
                <thead>
                  <tr>
                    {detalleColumns.map((col) => (
                      <th key={col}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {detalleRows.map((row, index) => (
                    <tr key={index}>
                      {detalleColumns.map((col) => (
                        <td key={col}>
                          {typeof row[col] === "number" &&
                          (
                            col.toLowerCase().includes("total") ||
                            col.toLowerCase().includes("saldo") ||
                            col.toLowerCase().includes("importe")
                          )
                            ? money(row[col])
                            : row[col]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </ModalBody>
      </Modal>

      <br />
    </>
  );
}

export default ReporteContadora;